import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';

@Injectable()
export class ScrollService {

  public scrollLeftFormat: number = 0;
  public scrollTopFormat: number = 0;

  constructor(
    private config: ConfigService
  ) { }


  scrollCenterBoxFormat(format) {
    let that = this;
    setTimeout(function () {
      let WidthSlide = document.getElementsByClassName('slide')[0].clientWidth - 10;
      let ThisBoxFormat = document.getElementById(format.split('|')[0]);
      if (ThisBoxFormat != null) {
        let scrollLeft = (ThisBoxFormat.offsetLeft - (WidthSlide / 2) + (ThisBoxFormat.offsetWidth / 2));
        let DivExtraLarge = document.getElementById('extra-large');
        let WidthExtraLarge = -DivExtraLarge.clientWidth;
        let limits = - (WidthExtraLarge + WidthSlide);

        if (scrollLeft < 0) {
          scrollLeft = 0;
        } else if (scrollLeft > limits) {
          scrollLeft = limits;
        }
        that.scrollLeftFormat = -scrollLeft;
      }

    }, 100);
  }

  scrollVERTICALCenterBoxFormat(format) {
    let that = this;
    setTimeout(function () {
      let VerticalSlide = document.getElementsByClassName('slide')[0].clientHeight - 10;
      let ThisBoxFormat = document.getElementById(format.split('|')[0]);
      if (ThisBoxFormat != null) {
        let scrollTop = (ThisBoxFormat.offsetTop - (VerticalSlide / 2) + (ThisBoxFormat.offsetHeight / 2));
        let DivExtraLarge = document.getElementById('extra-large');
        let HeightExtraLarge = -DivExtraLarge.clientHeight;
        let limits = - (HeightExtraLarge + VerticalSlide);

        if (scrollTop < 0) {
          scrollTop = 0;
        } else if (scrollTop > limits) {
          scrollTop = limits;
        }
        that.scrollTopFormat = scrollTop;
      }

    }, 100);
  }

  ResetScrollLeft(selectFormat: string) {
    ////console.log('ResetScrollLeft');
    let that = this;
    setTimeout(function () {
      let BoxSelected = document.getElementById(selectFormat);
      if (BoxSelected != null && (BoxSelected.className.indexOf('formatOK') > -1)) {
        // that.scrollCenterBoxFormat(selectFormat);
        // that.scrollVERTICALCenterBoxFormat(selectFormat);
      } else {
        that.scrollLeftFormat = 0;
        setTimeout(function () {
          that.simulatedClick(document.getElementsByClassName('riga-input hidden formatOK')[0]);
        }, 300);
      }
    }, 600);
  }

  simulatedClick(element) {
    //console.log('simulatedClick');
    if (element != null) {
      let d = document.createEvent('MouseEvents'),
        c = document.createEvent('MouseEvents'),
        p = document.createEvent('MouseEvents');
      d.initMouseEvent('mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      c.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      p.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);

      element.dispatchEvent(d);
      element.dispatchEvent(c);
      element.dispatchEvent(p);
    }
  }



  scrollLeft() {
    let WidthColumn = document.getElementsByClassName('boxFormat')[0].clientWidth;
    let newValueLeft = this.scrollLeftFormat + WidthColumn;
    let timeanimation = 0;

    if (newValueLeft + 100 > 0) {
      this.scrollLeftFormat = 30;
      newValueLeft = 0;
      timeanimation = 150;
    } else { }

    let that = this;
    setTimeout(function () {
      that.scrollLeftFormat = newValueLeft;
    }, timeanimation);

  }

  scrollRight() {
    let WidthColumn = document.getElementsByClassName('boxFormat')[0].clientWidth;
    let newValueLeft = this.scrollLeftFormat - WidthColumn;
    let WidthExtraLarge = -document.getElementById('extra-large').clientWidth;
    let WidthSlide = document.getElementsByClassName('slide')[0].clientWidth - 10;
    let limits = (WidthExtraLarge + WidthSlide);

    let timeanimation = 0;
    if (newValueLeft - 100 < limits) {
      this.scrollLeftFormat = limits - 30;
      newValueLeft = limits;
      timeanimation = 150;
    }

    let that = this;
    setTimeout(function () {
      that.scrollLeftFormat = newValueLeft;
    }, timeanimation);
  }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/scroll.service.ts